// @flow
import React, { Fragment, type Node } from 'react';
import { ThemeProvider as LibThemeProvider } from 'styled-components';

import DSTheme, { type Theme } from '@rover/design-system/style-dictionary/build/es6/theme';

export type Props = {|
  theme: Theme,
  children: Node,
|};

const ThemeProvider = ({ theme, children }: Props) => (
  <LibThemeProvider theme={theme}>
    <Fragment>{children}</Fragment>
  </LibThemeProvider>
);

ThemeProvider.defaultProps = {
  theme: DSTheme,
};

export default ThemeProvider;



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/ThemeProvider/ThemeProvider.jsx